<div data-test="e14zAsR0" class="login-logo">
  <div data-test="UY7-OVyg" class="login-logo-img"></div>
</div>

<div
  data-test="AJ3PqXsx"
  class="login__form"
  *ngIf="{
    loginForm: loginForm$ | async | notNull
  } as data"
>
  <div data-test="vRc3mrka" class="login__form-header">
    <h1 data-test="rG5w36z3">Login</h1>
    <p data-test="gwD6AjfL">Enter your details below.</p>
  </div>
  <form data-test="uQR9tpjj" class="form" [ngrxFormState]="data.loginForm">
    <div
      data-test="Z4g0dpx1"
      *ngIf="data.loginForm.errors.$unauthorized"
      class="form__error"
    >
      Password or Email is incorrect. Check it, please, again.
    </div>
    <div
      data-test="mOF1J3zw"
      class="form-group"
      [class.error]="
        data.loginForm.controls.username.isInvalid &&
        data.loginForm.controls.username.isDirty
      "
    >
      <label data-test="MNONecvI" class="form-group__label" for="input-1">E-mail</label>
      <input
        data-test="JaOuMuPm"
        class="input"
        id="input-1"
        type="email"
        name="username"
        placeholder="john@macs.com"
        [ngrxFormControlState]="data.loginForm.controls.username"
      />
    </div>
    <div data-test="5vxa1CWW" class="form-group">
      <label data-test="eJDRl_Or" class="form-group__label" for="input-2">Password</label>
      <div data-test="ApMcXo98" class="form-group__field form-group__field_append">
        <input
          data-test="0UA9EJ9A"
          class="input"
          id="input-2"
          type="password"
          name="password"
          placeholder="Enter your password"
          [ngrxFormControlState]="data.loginForm.controls.password"
          [attr.type]="showPassword ? 'text' : 'password'"
        />
        <span data-test="bm70wDEk" class="form-group__field-append">
          <button
            data-test="kA_2CFVJ"
            class="link-light"
            type="button"
            (click)="showPassword = !showPassword"
          >
            <i data-test="dyP0Oe-G" class="material-icons">visibility_off</i>
          </button>
        </span>
      </div>
    </div>
    <div data-test="PAwyAVLu" class="form-group text-right">
      <a
        data-test="1yHA3nCl"
        class="link text-small"
        [routerLink]="['../send-reset-email']"
      >
        Forgot password?
      </a>
    </div>
    <div data-test="18mgI8Wz" class="form-group">
      <button
        class="form-submit button button_primary w-100"
        [disabled]="
          !data.loginForm.controls.password.isValid ||
          !data.loginForm.controls.username.isValid
        "
        (click)="login()"
        [mdButtonSpinner]="loading$ | async | notNull"
        data-test="sign-in-btn"
      >
        {{ (loading$ | async | notNull) ? 'Signing In' : 'Sign In' }}
      </button>
    </div>
  </form>
</div>
